import axios from '../components/shared/axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const fetchCommunityApplication = async (params) => {
  try {
    const res = await axios.get(`${baseURL}/community/applications`, {
      params
    });
    const data = res.data;
    return {
      data: data,
      error: null
    };
  } catch (e) {
    return {
      data: null,
      error: e
    };
  }
};

export const fetchCommunityLogs = async (params) => {
  try {
    const res = await axios.get(`${baseURL}/community/mailstatus`, {
      params
    });
    const data = res.data;
    return {
      data: data,
      error: null
    };
  } catch (e) {
    return {
      data: null,
      error: e
    };
  }
};

export const fetchStartCommunityApplication = async (params) => {
  try {
    const res = await axios.get(
      `${baseURL}/community/start-community-applications`,
      {
        params
      }
    );
    const data = res.data;
    return {
      data: data,
      error: null
    };
  } catch (err) {
    return { data: null, error: err };
  }
};

export const submitStartCommunityApplicationStatus = async (params) => {
  try {
    const res = await axios.put(
      `${baseURL}/community/update-start-community-application-status/${params?._id}`,
      params
    );
    const data = res.data;

    return {
      data: data,
      error: null
    };
  } catch (e) {
    return {
      data: null,
      error: e
    };
  }
};
export const submitApplicationStatus = async (params) => {
  try {
    const res = await axios.put(
      `${baseURL}/community/${params?._id}/update-application-status`,
      params
    );
    const data = res.data;

    return {
      data: data,
      error: null
    };
  } catch (e) {
    return {
      data: null,
      error: e
    };
  }
};

export const submitManualApplication = async (params) => {
  try {
    const res = await axios.post(
      `${baseURL}/community/free-subscription`,
      params
    );
    const data = res.data;

    return {
      data: data,
      error: null
    };
  } catch (e) {
    return {
      data: null,
      error: e
    };
  }
};

//Community
export const getCommunities = async (params) => {
  return await axios.get(`${baseURL}/communities`, {
    params
  });
};

export const getCommunity = async (params) => {
  return await axios.get(`${baseURL}/community`, {
    params
  });
};

//Event
export const getCommunityEvent = async (params) => {
  return axios.get(`${baseURL}/community/event`, {
    params
  });
};

export const getCommunityEvents = async (params) => {
  return await axios.get(`${baseURL}/community/events`, {
    params
  });
};

export const createCommunityEvent = async (params) => {
  return await axios.post(`${baseURL}/community/event`, params);
};

export const updateCommunityEvent = async (params, id) => {
  return await axios.put(`${baseURL}/community/event/${id}`, params);
};

export const deleteCommunityEvent = async (id) => {
  return await axios.delete(`${baseURL}/community/event/${id}`);
};

//Resources
export const getCommunityResource = async (params) => {
  return axios.get(`${baseURL}/community/resource`, {
    params
  });
};

export const getCommunityResources = async (params) => {
  return await axios.get(`${baseURL}/community/resources`, {
    params
  });
};

export const createCommunityResource = async (params) => {
  return await axios.post(`${baseURL}/community/resource`, params);
};

export const updateCommunityResource = async (params, id) => {
  return await axios.put(`${baseURL}/community/resource/${id}`, params);
};

export const deleteCommunityResource = async (id) => {
  return await axios.delete(`${baseURL}/community/resource/${id}`);
};

//Videos
export const getCommunityVideos = async (params) => {
  return axios.get(`${baseURL}/community/videos`, {
    params
  });
};

// export const getCommunityResources = async (params) => {
//   return await axios.get(`${baseURL}/community/resources`, {
//     params
//   });
// };

// export const createCommunityResource = async (params) => {
//   return await axios.post(`${baseURL}/community/resource`, params);
// };

// export const updateCommunityResource = async (params, id) => {
//   return await axios.put(`${baseURL}/community/resource/${id}`, params);
// };

// export const deleteCommunityResource = async (id) => {
//   return await axios.delete(`${baseURL}/community/resource/${id}`);
// };

//Posts
export const getCommunityPost = async (params) => {
  return axios.get(`${baseURL}/community/post`, {
    params
  });
};

export const getCommunityPosts = async (params) => {
  return await axios.get(`${baseURL}/community/posts`, {
    params
  });
};

export const createCommunityPost = async (params) => {
  return await axios.post(`${baseURL}/community/post`, params);
};

export const updateCommunityPost = async (params, id) => {
  return await axios.put(`${baseURL}/community/post/${id}`, params);
};

export const deleteCommunityPost = async (id) => {
  return await axios.delete(`${baseURL}/community/post/${id}`);
};

export const updateApplication = async (params) => {
  try {
    const res = await axios.put(
      `${baseURL}/community/application/${params._id}`,
      params
    );
    const data = res.data;

    return {
      data: data,
      error: null
    };
  } catch (e) {
    return {
      data: null,
      error: e
    };
  }
};

export const updateStartCommunityApplication = async (params) => {
  try {
    const res = await axios.put(
      `${baseURL}/community/start-community-application/${params?._id}`,
      params
    );
    const data = res.data;

    return {
      data: data,
      error: null
    };
  } catch (e) {
    return {
      data: null,
      error: e
    };
  }
};
